<div class="content">
  <div class="table-wrapper custom-table">
    <mat-table
      #table
      matSort
      matSortActive="invoiceNumber"
      matSortDirection="desc"
      matSortDisableClear
      [dataSource]="dataSource.delegationsInvoices$ | async"
      >
      <ng-container matColumnDef="invoiceNumber">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
          {{ 'DCL-InvoiceNumber' | translate }}
          <app-table-header-sort></app-table-header-sort>
        </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <app-copy [value]="element.InvoiceNumber">
            {{ element.InvoiceNumber }}
          </app-copy>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="description">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
          {{ 'DCL-Description' | translate }}
          <app-table-header-sort></app-table-header-sort>
        </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <app-copy [value]="element.Description">
            {{ element.Description }}
          </app-copy>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="delegationInvoiceTypeName">
        <mat-header-cell *matHeaderCellDef mat-sort-header="DelegationInvoiceTypeName" class="hidden-sort">
          {{ 'DCL-Category' | translate }}
          <app-table-header-sort></app-table-header-sort>
        </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <app-copy [value]="element.DelegationInvoiceTypeNames?.join(' | ')">
            {{ element.DelegationInvoiceTypeNames?.join(' | ') }}
          </app-copy>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="grossValue">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
          {{ 'DCL-GrossValue' | translate }}
          <app-table-header-sort></app-table-header-sort>
        </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <app-copy [value]="element.GrossValue">
            {{ element.GrossValue }}
          </app-copy>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="currencyName">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
          {{ 'DCL-Currency' | translate }}
          <app-table-header-sort></app-table-header-sort>
        </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <app-copy [value]="element.CurrencyName">
            {{ element.CurrencyName }}
          </app-copy>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="paymentTypeName">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
          {{ 'DCL-PaymentType' | translate }}
          <app-table-header-sort></app-table-header-sort>
        </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <app-copy [value]="element.PaymentTypeName">
            {{ element.PaymentTypeName }}
          </app-copy>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="issueDate">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
          {{ 'DCL-IssueDate' | translate }}
          <app-table-header-sort></app-table-header-sort>
        </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <app-copy [value]="element.IssueDate | date : 'yyyy-MM-dd'">
            {{ element.IssueDate | date : 'yyyy-MM-dd' }}
          </app-copy>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="actions">
        <mat-header-cell *matHeaderCellDef> {{ 'Actions' | translate }} </mat-header-cell>
        <mat-cell *matCellDef="let element">
          @if (element.Files?.length) {
            <button id="delegation-invoice-list-files-button" mat-icon-button (click)="openFilesModal(element)">
              <mat-icon>find_in_page</mat-icon>
            </button>
          }
          <button mat-icon-button id="delegation-invoice-list-details-button" (click)="openDetailsModal(element)">
            <mat-icon>visibility</mat-icon>
          </button>

          @if (canEdit) {
            <button mat-icon-button id="delegation-invoice-list-delete-cost-button" (click)="deleteDelegationCost(element.DelegationId, element.DelegationCostId)">
              <mat-icon>delete</mat-icon>
            </button>
            } @if (canEdit) {
            <button mat-icon-button id="delegation-invoice-list-edit-button" (click)="openEditModal(element)">
              <mat-icon>edit</mat-icon>
            </button>
          }
        </mat-cell>
      </ng-container>
      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
    </mat-table>
  </div>

  <mat-paginator [length]="dataSource.count$ | async" [pageSize]="10" [pageSizeOptions]="[10, 15, 20]"> </mat-paginator>
</div>
